import React, { useEffect, useState } from 'react';
import { Button, Skeleton, Space, Table, TableProps, Typography } from 'antd';
import { ICard } from '../../../interfaces/card';
import { ColumnsType } from 'antd/es/table';
import { getDateFormatted, sortDateDesc } from '../../../utils/date';
import { CARD_STATE_TO_HUMAN_TEXT, CARD_TYPE_TO_HUMAN_TEXT } from '../../../constants';
import useGetAllCards from 'hooks/data/useGetAllCards';
import { FirstStepFormInputs, SecondStepFormInputs } from '../claim-new';

type SecondStepProps = {
  goToPrevious?: () => void | null;
  goToNext?: () => void | null;
  firstStepData?: FirstStepFormInputs | null;
  setSecondStepData?: (data: SecondStepFormInputs) => void | null;
  secondStepData?: SecondStepFormInputs | null;
};

const SecondStep: React.FC<SecondStepProps>  = ({
  goToPrevious,
  goToNext,
  firstStepData,
  setSecondStepData,
  secondStepData,
}) => {

  const { cards, pageInfo, isLoading } = useGetAllCards(
      0,
      100,
      {
        cardholder: firstStepData.cardHolder.id
      }
  );

  const columns: ColumnsType<ICard> = [
    {
      dataIndex: 'card_id',
      key: 'card_id',
      title: 'ID',
    },
    {
      dataIndex: 'created_time',
      key: 'created_time',
      title: 'Fecha de Creacion',
      defaultSortOrder: 'descend',
      sorter: (a, b) => sortDateDesc(b.created_time, a.created_time),
      render: (_, record) => {
        return getDateFormatted(record.created_time);
      },
    },
    {
      dataIndex: 'card_type',
      key: 'card_type',
      title: 'Tipo',
      render: (_, record) => {
        return CARD_TYPE_TO_HUMAN_TEXT[record.card_type];
      },
    },
    {
      dataIndex: 'state',
      key: 'state',
      title: 'Estado',
      width: 150,
      render: (_, record) => {
        return CARD_STATE_TO_HUMAN_TEXT[record.state];
      },
    },
    { dataIndex: 'last_four', key: 'last_four', title: 'Ultimos 4 Digitos' },
    { dataIndex: 'ownership_level', title: 'Ownership', key: 'ownership_level' },
  ];

  const rowSelection: TableProps<ICard>['rowSelection'] = {
    type: "radio",
    selectedRowKeys: (secondStepData !== null && secondStepData.card !== null) ? [secondStepData.card.card_id] : [],
    onChange: (selectedRowKeys: React.Key[], selectedRows: ICard[]) => {
      setSecondStepData({card: selectedRows[0]});
      console.log("selectedRow: ", selectedRows[0]);
    },
    columnWidth: 60, // Optional, makes the column tighter
    renderCell: (checked, record, index, originNode) => (
      <div style={{ display: 'flex', justifyContent: 'center', padding:'0px' }}>{originNode}</div>
    )
  };
  

  return (
    <div>
      <Typography.Title level={2}>Selección de Tarjeta</Typography.Title>

      {
        isLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} style={{marginTop:'1em'}} />
        ) : (

          <Table<ICard>
              style={{marginTop:'1em'}}
              rowKey={"card_id"}
              rowSelection={{ type: 'radio', ...rowSelection }}
              dataSource={cards || []}
              scroll={{ x: true }}
              // @ts-ignore
              columns={columns.filter((e) => Object.keys(e).length > 0)}
              pagination={false}
          />
        )}


      <div style={{ width: 'max-content', maxWidth: '100%', margin: 'auto', marginTop:'1em' }}>
        <Button onClick={goToPrevious} type="primary">
          Anterior
        </Button>
        <Button disabled={secondStepData === null} onClick={goToNext} type="primary" style={{ left: '10px'}}>
          Siguiente
        </Button>
      </div>
    </div>
  )
}

export default SecondStep;

